/** Phone / PWA: open the server view URL in the browser instead of a blob iframe. */
export function shouldOpenCogginsPdfInNewTab(): boolean {
  if (typeof window === 'undefined') return false;

  const ua = navigator.userAgent;
  const isIos =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /Android/i.test(ua);
  const standalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true;
  const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
  const narrowScreen = window.matchMedia('(max-width: 768px)').matches;

  if (isIos) return true;
  if (standalone && (isIos || isAndroid)) return true;
  if (narrowScreen && coarsePointer) return true;
  return false;
}
